export const isNullOrUndefined = <T>(value: T | undefined | null) =>
  value === undefined || value === null
